import React, { useEffect, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import { FaEye, FaEyeSlash, FaShoppingCart, FaTrashAlt } from "react-icons/fa";
import Config from "../Header/Config";
import { ToastContainer, toast } from 'react-toastify';
import { useLocation, useNavigate } from "react-router-dom";

export default function Enquiry_update() {
  const apiUrl = Config.apiUrl;
  const [customer_name, setcustomer_name] = useState("");
  const [contact_number, setcontact_number] = useState("");
  const [date, setdate] = useState("");
  const [model_name, setmodel_name] = useState("");


  const navigate = useNavigate();

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  //........................................

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (id) {
          const response = await fetch(`${apiUrl}/searchEnquiry/${id}`);
          const data = await response.json();
          console.log(data);
          setcustomer_name(data.data.customer_name || '');
          setcontact_number(data.data.contact_number || '');
          // normalize date: API may return `date` or a datetime string
          const rawDate = data.data.date || data.data.created_at || data.data.updated_at || data.data.data || '';
          const normalizedDate = rawDate ? String(rawDate).split('T')[0].split(' ')[0] : '';
          setdate(normalizedDate);
          setmodel_name(data.data.model_name || '');
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [id]);

  //.............................................................

  const [updatedDetails, setUpdatedDetails] = useState([])
  const updateEnquiry = async () => {
    const item = {
      customer_name: customer_name,
      contact_number: contact_number,
      date: date,
      model_name: model_name,

    };

    try {
      const result = await fetch(`${apiUrl}/update_enquiry/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      if (result.ok) {

        setUpdatedDetails(updatedDetails);

        setcustomer_name('');
        setcontact_number('');
        setdate('');
        setmodel_name('');



        navigate("/enquirylist")


      } else {
        alert("Failed to update Enquiry");
      }
    } catch (error) {
      console.log(error);
      alert("Failed to update Enquiry");
    }
  };


  return (
    <div className="layout-wrapper layout-content-navbar">


      <div className="layout-container">
        <Header />

        <div className="layout-page">
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Enquiry Details</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Enquiry Details</h5>
                  </div>
                  <div className="card-body">
                    <div>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-email"
                          >
                            Customer Name
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-email"
                              className="form-control"
                              placeholder="Enter Customer Name"
                              aria-label="john.doe"
                              aria-describedby="basic-default-email2"
                              value={customer_name}
                              onChange={(e) => {
                                const v = capitalizeWords(e.target.value);
                                setcustomer_name(v);
                              }}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-email"
                          >
                            Mobile Number
                          </label>
                          <div className="input-group input-group-merge">
                            <input
                              type="text"
                              id="basic-default-email"
                              className="form-control"
                              placeholder="Enter Mobile Number"
                              aria-label="john.doe"
                              aria-describedby="basic-default-email2"
                              value={contact_number}
                              onChange={(e) => {
                                const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                setcontact_number(value);
                              }}
                              maxLength={10}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-company"
                          >
                            Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="basic-default-date"
                            placeholder="Enter date"
                            value={date}
                            onChange={(e) => setdate(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-company"
                          >
                            Model Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="basic-default-amount"
                            placeholder="Enter Model Name"
                            value={model_name}
                            onChange={(e) => setmodel_name(e.target.value)}
                          />
                        </div>

                        {/* <div className="col-md-6 mb-3">
                          <label
                            className="form-label"
                            htmlFor="basic-default-phone"
                          >
                            Opening Stock
                          </label>
                          <input
                            type="number"
                            id="basic-default-phone"
                            className="form-control phone-mask"
                            placeholder="Enter Opening Stock"
                            value={openingStock}
                            onChange={(e) => setOpeningStock(e.target.value)}
                          />
                        </div> */}


                        <div className="col-12">
                          <div className="col-12 d-flex justify-content-end">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                              onClick={() => updateEnquiry()}
                            >

                              Update
                            </button>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <Footer />

            <div className="content-backdrop fade" />
          </div>
        </div>
      </div>

      <div className="layout-overlay layout-menu-toggle" />
    </div>
  )
}
